<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg order-1 order-md-1"></div>
        <div class="contents order-2 order-md-2">

            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <h3 class="mb-3">Rejoignez la communauté</h3>
                        <!-- <p class="mb-4">Lorem ipsum dolor sit amet elit.</p> -->
                        <form @submit.prevent="register()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Nom Complet</label>
                                        <input type="text" id="full_name" class="form-control"
                                            v-model="userData.full_name" required>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">E-mail</label>
                                        <input type="email" id="email" class="form-control" v-model="userData.email"
                                            required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">N° Téléphone</label>
                                        <input type="text" id="phone" class="form-control"
                                            v-model="userData.phone_number" pattern="[1-9][0-9]{7}" required>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">N° Whatsapp</label>
                                        <input type="text" id="phone" class="form-control whatsapp"
                                            v-model="userData.whatsapp_number" pattern="[1-9][0-9]{7}" required>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Adresse</label>
                                        <input type="text" id="address" class="form-control" v-model="userData.address">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Délégation</label>
                                        <v-select :options="delegations" v-model="userData.delegation" label="option" :reduce="option => option" class="custom-vs form-control input" :class="{ invalid: errors.delegation }">
                                            <template #option="{ option }">
                                                <span><b>{{ option.split(', ')[0]}}</b>, {{ option.split(', ')[1] }}</span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">Mot de Passe</label>
                                <input type="password" id="password" class="form-control" v-model="userData.password"
                                    required>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary btn-block btn-lg btn-rounded login-btn" type="submit">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">S'inscrire</label>
                                </button>
                            </div>
                            <div v-if="formError" class="alert alert-danger mt-3 mb-0" role="alert">
                                {{ formError }}
                            </div>
                            <div class="form-group h-100 mb-0 mt-1 text-xs text-black-50">
                                <label class="d-inline">En cliquant sur "S’inscrire", vous acceptez
                                    <a href="/cgu" target="_blank" style="text-decoration: underline">nos Conditions d'Utilisation</a> et
                                    <a href="/privacy-policy" target="_blank" style="text-decoration: underline">notre Politique de
                                        Confidentialité</a>.
                                </label>
                            </div>
                            <div class="login-or">
                                <span class="or-line"></span>
                                <span class="span-or">ou</span>
                            </div>
                            <div class="row form-row social-login">
                                <div class="col-6">
                                    <a href="#" class="btn btn-facebook btn-block btn-rounded"
                                        @click.prevent="socialLogin('facebook')">
                                        <i class="fab fa-facebook-f mr-1"></i> Continuer avec Facebook
                                    </a>
                                </div>
                                <div class="col-6">
                                    <a href="#" class="btn btn-google btn-block btn-rounded" @click.prevent="socialLogin('google')">
                                        <i class="fab fa-google mr-1"></i> Continuer avec Google
                                    </a>
                                </div>
                            </div>
                            <div class="text-center dont-have mb-3">
                                Vous avez déjà un compte? 
                                <a :href="$router.resolve({ name: 'login' }).href"><b>Se connecter</b></a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Page Content -->
</template>
<script>
import vSelect from "vue-select";
import { api } from '@/store';
import { mapActions } from 'vuex';

import "vue-select/dist/vue-select.css";
export default {
    components: {
        vSelect
    },
    data() {
        return {
            errors: [],
            formError: '',
            delegations: [],
            userData: {
                full_name: '',
                email: '',
                phone_number: '',
                whatsapp_number: '',
                delegation: '',
                address: '',
                password: ''
            }
        }
    },
    created() {
        this.getDelegations()
    },
    methods: {
        ...mapActions(['login']), // Map login action from Vuex store
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async register() {
            try {
                this.formError = ''
                $('.submit-section button').attr('disabled', 'disabled')
                $('.submit-section button span').removeClass('d-none')
                this.clearForm();
                const response = await api.post('/auth/register', this.userData); // Corrected path
                $('.submit-section button').removeAttr('disabled')
                $('.submit-section button span').addClass('d-none')
                const data = response.data;
                if (response.status === 201 && data.id) {
                    this.$router.push({ "name": "login" });
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.data.detail && error.response.data.detail === "REGISTER_USER_ALREADY_EXISTS") {
                        $("#email").addClass('is-invalid');
                        $("#email").closest('.form-group').find('.invalid-feedback').remove(); // Remove any existing feedback messages
                        $("#email").closest('.form-group').append(
                            '<span class="invalid-feedback mt-0" role="alert">Email Already Exists</span>'
                        );
                    } else if (error.response.data.detail && error.response.data.detail === "PHONE_ALREADY_EXISTS") {
                        $("#phone").addClass('is-invalid');
                        $("#phone").closest('.form-group').find('.invalid-feedback').remove(); // Remove any existing feedback messages
                        $("#phone").closest('.form-group').append(
                            '<span class="invalid-feedback mt-0" role="alert">Phone Already Exists</span>'
                        );
                    } else if (error.response.data.detail && error.response.data.detail === "WHATSAPP_ALREADY_EXISTS") {
                        $(".whatsapp").addClass('is-invalid');
                        $(".whatsapp").closest('.form-group').find('.invalid-feedback').remove();
                        $(".whatsapp").closest('.form-group').append(
                            '<span class="invalid-feedback mt-0" role="alert">Whatsapp Already Exists</span>'
                        );
                    } else if (error.response.status === 422) {
                        const rawErrors = error.response.data.detail;
                        rawErrors.forEach(err => {
                            const field = err.loc[0]; // e.g., "username"
                            this.errors[field] = err.msg; // e.g., "field required"
                        });
                    }
                } else {
                    console.error('Unexpected error:', error);
                }
                $('.submit-section button').removeAttr('disabled')
                $('.submit-section button span').addClass('d-none')
            }
        },
        async getStates() {
            return await api.get('/states')
                .then(response => {
                    const result = response.data
                    this.states = result
                })
        },

        async socialLogin(provider) {
            this.clearForm();
            try {
                // Make request to your backend to initiate social login (corrected path)
                const response = await api.get(`/auth/${provider}/authorize`); // Use the proper endpoint
                window.location.href = response.data.authorization_url; // Redirect to the provider's authorization page
            } catch (error) {
                $('.social-login').append(
                    '<span class="invalid-feedback d-block mt-0 pl-1" role="alert">' + error.response.data.error + '</span>'
                );
                console.error('Login error via social network:', error.response.data.error);
            }
        },

        clearForm() {
            $('.invalid-feedback').remove();
            $('.form-control.is-invalid').removeClass('is-invalid');
        }
    }
}
</script>
